<template>
  <f-form-group
    v-if="field_visible"
    :field-errors="fieldErrors"
    :required="field.required"
    :label="field_label"
    :hide-label="hideLabel"
    :horizontal="horizontal"
    v-b-tooltip="tooltip"
  >
    <b-form-select
      :disabled="is_disabled"
      :label="field_label"
      :value="field_value"
      @input="on_input"
      v-bind="field.params"
      :options="effectiveOptions"
      v-if="layout === 'select'"
    >
      <b-form-select-option
        v-if="field.params.placeholder"
        :value="null"
        disabled
        >{{ field.params.placeholder }}
      </b-form-select-option>
    </b-form-select>

    <b-form-radio-group
      :checked="field_value"
      :disabled="is_disabled"
      :label="field_label"
      :stacked="field.params.stacked"
      :options="effectiveOptions"
      @input="on_input"
      v-bind="field.params"
      v-if="layout === 'radios'"
    ></b-form-radio-group>

    <b-form-radio-group
      :checked="field_value"
      :label="field_label"
      :stacked="field.params.stacked"
      :options="effectiveOptions"
      @input="on_input"
      :disabled="is_disabled"
      button-variant="outline-secondary"
      buttons
      v-bind="field.params"
      v-if="layout === 'buttons'"
    ></b-form-radio-group>

    <b-list-group v-if="layout === 'list_group'">
      <b-list-group-item
        v-for="option in effectiveOptions"
        :key="option.value"
        @click="option_clicked(option)"
        :active="is_active(option)"
        :disabled="is_disabled || !!option.disabled"
      >
        <checkbox-outline-icon v-if="is_active(option)" />
        <checkbox-blank-outline-icon v-if="!is_active(option)" />
        <span class="pl-1">{{ option.text }}</span></b-list-group-item
      >
    </b-list-group>
  </f-form-group>
</template>

<script>
import FormWidgetMixin from "../FormWidgetMixin.js";
import AjaxOptionsMixin from "../AjaxOptionsMixin.js";
import FFormGroup from "../FFormGroup.vue";
import CheckboxOutlineIcon from "vue-material-design-icons/CheckBoxOutline.vue";
import CheckboxBlankOutlineIcon from "vue-material-design-icons/CheckboxBlankOutline.vue";

export default {
  name: "MultiSelectWidget",
  components: { FFormGroup, CheckboxOutlineIcon, CheckboxBlankOutlineIcon },
  mixins: [FormWidgetMixin, AjaxOptionsMixin],
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    is_active(option) {
      if (this.field_value && this.field_value.indexOf(option.value) !== -1) {
        return true;
      } else if (this.selected.indexOf(option.value) !== -1) {
        return true;
      }

      return false;
    },
    option_clicked(option) {
      if (this.disabled || option.disabled) {
        return;
      }
      var temp_field_value = [];
      if (this.field_value && this.field_value.indexOf(option.value) === -1) {
        this.field_value.push(option.value);
        this.on_input(this.field_value);
        return;
      } else if (
        this.field_value &&
        this.field_value.indexOf(option.value) !== -1
      ) {
        temp_field_value = this.field_value.filter((item) => {
          return item !== option.value;
        });
        this.selected = this.selected.filter((item) => {
          return item !== option.value;
        });
        this.on_input(temp_field_value);
        return;
      }

      if (this.selected.indexOf(option.value) === -1) {
        this.selected.push(option.value);
        this.on_input(this.selected);
      } else if (this.selected.indexOf(option.value) !== -1) {
        this.selected = this.selected.filter((item) => {
          return item !== option.value;
        });
        this.on_input(this.selected);
      }
    },
  },
  computed: {
    layout() {
      return this.field.params.layout || "list_group";
    },
  },
};
</script>
